// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Navigation tabs
export const NAVIGATION_TABS = [
  { id: 'home', label: 'Home' },
  // { id: 'stream', label: 'Live Stream' },
  { id: 'newsletter', label: 'Newsletter' },
  { id: 'events', label: 'Events' },
  { id: 'contact', label: 'Contact' },
  { id: 'admin', label: 'Admin', adminOnly: true }
];

// Church information
export const CHURCH_INFO = {
  name: 'KOGK Christian Ministry',
  contact: {
    email: 'admin@kogkministry.org'
  },
  serviceTimes: {
    sunday: '10:30 AM',
    sundayAfternoon: '2:00 PM',
    wednesday: '7:30 PM'
  }
};

// Admin credentials (temporary - move to backend in production)
export const ADMIN_CONFIG = {
  username: 'admin',
  password: 'kogk2024', // Change this!
  sessionTimeout: 3600000 // 1 hour
};

// Sample events data
export const SAMPLE_EVENTS = [
  {
    title: 'Sunday School Service',
    time: '10:30 AM - 1:30 PM',
  },
  {
    title: 'Sunday Afternoon Service',
    time: '2:00 PM - 5:00 PM',
  },
  {
    title: 'Wednesday Night Bible Study',
    time: '7:30 PM - 10:00 PM',
  },
];